// @dev: replace this value with the name of the widget you're building
//       (ex: m-widget-connect, m-burn-redeem-complete, etc.)
export const DATA_WIDGET_VALUE = 'm-widget-subscribe';

export const M_SUBSCRIBE_SUCCESS_EVENT = 'm-subscribe-success';
export const M_SUBSCRIBE_ERROR_EVENT = 'm-subscribe-error';
export const M_SUBSCRIBE_SUBMIT_EVENT = 'm-subscribe-submit';
